import { render, staticRenderFns } from "./sale_channels.vue?vue&type=template&id=186ef552"
import script from "./sale_channels.vue?vue&type=script&lang=js"
export * from "./sale_channels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports